<div id="product" class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div class="header accent" fxLayout="row" fxLayoutAlign="space-between center">
            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">
                <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/clientes/consulta'">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div
                    class="product-image mr-8 mr-sm-16"
                    [@animate]="{ value: '*', params: { delay: '50ms', scale: '0.2' } }"
                >
                    <mat-icon class="logo-icon s-32 mr-16"> account_box </mat-icon>
                </div>

                <div
                    fxLayout="column"
                    fxLayoutAlign="start start"
                    [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }"
                >
                    <div class="h2" *ngIf="isClienteId()">
                        Dados do Cliente - {{ dadosCadastraisFormGroup.get("nome")?.value }}
                    </div>
                    <div class="h2" *ngIf="!isClienteId()">Novo Cliente</div>
                </div>
            </div>
            <!-- / APP TITLE -->
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- CONTENT -->
            <div class="content">
                <mat-horizontal-stepper [linear]="isLinear" #stepper>
                    <!-- dados cadastrais -->
                    <mat-step [stepControl]="dadosCadastraisFormGroup">
                        <form [formGroup]="dadosCadastraisFormGroup" (ngSubmit)="salvar(stepper)">
                            <ng-template matStepLabel>Dados Cadastrais</ng-template>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="23">
                                    <mat-label>Conta BTG</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        formControlName="numero_xp"
                                        placeholder="Conta BTG"
                                        name="numero_xp"
                                        (change)="verificaContaCliente()"
                                    />
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="19">
                                    <mat-label>Tipo de Cliente</mat-label>
                                    <mat-select
                                        required
                                        [(ngModel)]="model.tipo_pessoa"
                                        name="tipo_pessoa"
                                        formControlName="tipo_pessoa"
                                        (selectionChange)="changeTipoCliente()"
                                    >
                                        <mat-option value="PF">Pessoa Física</mat-option>
                                        <mat-option value="PJ">Pessoa Jurídica</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="60">
                                    <mat-label>Nome</mat-label>
                                    <input
                                        matInput
                                        placeholder="Nome"
                                        formControlName="nome"
                                        name="nome"
                                        required
                                        maxlength="255"
                                        style="text-transform: uppercase"
                                    />
                                    <!-- <mat-error *ngIf="dadosCadastraisFormGroup.get('nome')?.invalid">{{getErrorNomeFantasiaMessage()}}</mat-error> -->
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="19" *ngIf="isCnpj">
                                    <mat-label>CNPJ</mat-label>
                                    <input
                                        matInput
                                        placeholder="CNPJ"
                                        formControlName="cnpj"
                                        name="cnpj"
                                        maxlength="20"
                                        mask="00.000.000/0000-00"
                                    />
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="19" *ngIf="isCpf">
                                    <mat-label>CPF</mat-label>
                                    <input
                                        matInput
                                        placeholder="CPF"
                                        formControlName="cpf"
                                        name="cpf"
                                        maxlength="15"
                                        mask="000.000.000-00"
                                    />
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" *ngIf="isCnpj">
                                    <mat-label>Razão Social</mat-label>
                                    <input
                                        matInput
                                        placeholder="Razão Social"
                                        formControlName="razao_social"
                                        name="razao_social"
                                        required
                                        maxlength="255"
                                    />
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Data de Nascimento</mat-label>
                                    <input
                                        matInput
                                        [matDatepicker]="picker"
                                        formControlName="data_nascimento"
                                        name="data_nascimento"
                                        placeholder="Data de Nascimento"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Celular/WhatsApp</mat-label>
                                    <input
                                        matInput
                                        placeholder="Celular/WhatsApp"
                                        formControlName="telefone"
                                        required
                                        name="telefone"
                                    />
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>E-mail</mat-label>
                                    <input
                                        matInput
                                        placeholder="E-mail"
                                        formControlName="email"
                                        maxlength="255"
                                        name="email"
                                        required
                                    />
                                </mat-form-field>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="space-between">
                                <div fxFlex.gt-sm="20" fxFlex="100" class="p-10">
                                    <mat-label>Qual é o melhor canal para nos comunicarmos?</mat-label>
                                </div>
                                <div fxFlex.gt-sm="20" fxFlex="100" class="p-10">
                                    <div fxFlex.gt-sm="10" fxFlex="50" class="p-10">
                                        <mat-checkbox
                                            class="p-10"
                                            formControlName="comunicacao_celular"
                                            name="comunicacao_celular"
                                            >Celular</mat-checkbox
                                        >
                                    </div>
                                    <div fxFlex.gt-sm="10" fxFlex="50" class="p-10">
                                        <mat-checkbox
                                            class="p-10"
                                            formControlName="comunicacao_whatsapp"
                                            name="comunicacao_whatsapp"
                                            >WhatsApp</mat-checkbox
                                        >
                                    </div>
                                    <div fxFlex.gt-sm="10" fxFlex="50" class="p-10">
                                        <mat-checkbox
                                            class="p-10"
                                            formControlName="comunicacao_email"
                                            name="comunicacao_email"
                                            >E-mail</mat-checkbox
                                        >
                                    </div>
                                </div>
                                <br />
                                <br />
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field
                                    appearance="outline"
                                    floatLabel="always"
                                    style="width: 100%"
                                    fxFlex="30"
                                >
                                    <mat-label>Sexo</mat-label>
                                    <mat-select [(value)]="model.sexo" formControlName="sexo">
                                        <mat-option value="">SELECIONE</mat-option>
                                        <mat-option [value]="'M'">Masculino</mat-option>
                                        <mat-option [value]="'F'">Feminino</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field
                                    appearance="outline"
                                    floatLabel="always"
                                    style="width: 100%"
                                    fxFlex="30"
                                >
                                    <mat-label>Estado Civil</mat-label>
                                    <mat-select [(value)]="model.estado_civil_id" formControlName="estado_civil_id">
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option
                                            *ngFor="let estadoCivil of listEstadoCivil"
                                            [value]="estadoCivil.id"
                                            >{{ estadoCivil.nome }}</mat-option
                                        >
                                    </mat-select>
                                    <mat-spinner diameter="20" *ngIf="loadingSpinnerEstadoCivil"></mat-spinner>
                                </mat-form-field>
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Profissão</mat-label>
                                    <mat-select
                                        placeholder="Profissão"
                                        [(value)]="model.profissao_id"
                                        formControlName="profissao_id"
                                        name="profissao_id"
                                    >
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option *ngFor="let profissao of listProfissao" [value]="profissao.id">{{
                                            profissao.nome
                                        }}</mat-option>
                                    </mat-select>
                                    <mat-spinner diameter="20" *ngIf="loadingSpinnerProfissao"></mat-spinner>
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Suitability</mat-label>
                                    <mat-select
                                        [(value)]="model.perfil_id"
                                        formControlName="perfil_id"
                                        name="perfil_id"
                                    >
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option *ngFor="let perfil of listPerfil" [value]="perfil.id">{{
                                            perfil.nome
                                        }}</mat-option>
                                    </mat-select>
                                    <mat-spinner diameter="20" *ngIf="loadingSpinnerPerfil"></mat-spinner>
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Situação Tributária</mat-label>
                                    <mat-select
                                        placeholder="Situação Tributária"
                                        [(value)]="model.tipo_situacao_tributaria"
                                        formControlName="tipo_situacao_tributaria"
                                        name="tipo_situacao_tributaria"
                                        required
                                    >
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option
                                            *ngFor="let situacao of listSituacaoTributaria"
                                            [value]="situacao.id"
                                            >{{ situacao.nome }}</mat-option
                                        >
                                    </mat-select>
                                    <mat-spinner diameter="20" *ngIf="loadingSpinnerSituacao"></mat-spinner>
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Assessor</mat-label>
                                    <mat-select
                                        placeholder="Assessor"
                                        [(value)]="model.assessor_id"
                                        formControlName="assessor_id"
                                        required
                                        name="assessor_id"
                                    >
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{
                                            assessor.name
                                        }}</mat-option>
                                    </mat-select>
                                    <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Cliente Prospect?</mat-label>
                                    <mat-select
                                        (click)="setRequired()"
                                        [(ngModel)]="model.cliente_prosp"
                                        formControlName="cliente_prosp"
                                        name="cliente_prosp"
                                    >
                                        <mat-option value="true">SIM</mat-option>
                                        <mat-option value="false">NÃO</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Origem do Cliente</mat-label>
                                    <mat-select
                                        placeholder="Origem"
                                        [(value)]="model.origem_cliente_id"
                                        formControlName="origem_cliente_id"
                                        name="origem_cliente_id"
                                    >
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option *ngFor="let origem of listOrigem" [value]="origem.id">{{
                                            origem.nome
                                        }}</mat-option>
                                    </mat-select>
                                    <mat-spinner diameter="20" *ngIf="loadingSpinnerOrigem"></mat-spinner>
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Classificação do Cliente</mat-label>
                                    <mat-select
                                        placeholder="Classificação"
                                        [(value)]="model.primeiro_contato_id"
                                        formControlName="primeiro_contato_id"
                                        name="primeiro_contato_id"
                                    >
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option
                                            *ngFor="let classificao of listPrimeiroContato"
                                            [value]="classificao.id"
                                        >
                                            {{ classificao.nome }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-spinner diameter="20" *ngIf="loadingSpinnerPrimeiro"></mat-spinner>
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="15">
                                    <mat-label>CEP</mat-label>
                                    <input
                                        type="number"
                                        matInput
                                        placeholder="CEP"
                                        formControlName="cep"
                                        name="cep"
                                        (blur)="getEnderecoByCep()"
                                        maxlength="255"
                                        required
                                    />
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="10">
                                    <mat-label>Tipo Endereço</mat-label>
                                    <mat-select
                                        placeholder="Tipo Endereço"
                                        [(value)]="model.tipo_endereco"
                                        formControlName="tipo_endereco"
                                        name="tipo_endereco"
                                        required
                                    >
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option value="R">Residencial</mat-option>
                                        <mat-option value="C">Comercial</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Estado</mat-label>
                                    <mat-select
                                        placeholder="Estado"
                                        (selectionChange)="getAllCidades($event)"
                                        [(value)]="model.estado_id"
                                        formControlName="estado_id"
                                        [disabled]="isDisabledEstado()"
                                        name="estado_id"
                                        required
                                    >
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option *ngFor="let estado of listEstados" [value]="estado.id">{{
                                            estado.nome
                                        }}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Cidade</mat-label>
                                    <mat-select
                                        placeholder="Cidade"
                                        [(value)]="model.cidade_id"
                                        formControlName="cidade_id"
                                        [disabled]="isDisabledCidade()"
                                        name="cidade_id"
                                        required
                                    >
                                        <mat-option value="">Selecione...</mat-option>
                                        <mat-option *ngFor="let cidade of listCidades" [value]="cidade.id">{{
                                            cidade.nome
                                        }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Bairro</mat-label>
                                    <input
                                        matInput
                                        placeholder="Bairro"
                                        formControlName="bairro"
                                        maxlength="255"
                                        name="bairro"
                                        required
                                    />
                                </mat-form-field>
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Endereço</mat-label>
                                    <input
                                        matInput
                                        placeholder="Endereço"
                                        formControlName="endereco"
                                        maxlength="255"
                                        name="endereco"
                                        required
                                    />
                                </mat-form-field>
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                    <mat-label>Número</mat-label>
                                    <input
                                        matInput
                                        placeholder="Número"
                                        formControlName="numero"
                                        maxlength="255"
                                        name="numero"
                                    />
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                                    <mat-label>Complemento</mat-label>
                                    <input
                                        matInput
                                        placeholder="Complemento"
                                        formControlName="complemento"
                                        maxlength="255"
                                        name="complemento"
                                    />
                                </mat-form-field>
                            </div>
                            <div>
                                <button mat-button color="primary" type="submit">
                                    Avançar <mat-icon class="s-20">navigate_next</mat-icon>
                                </button>
                            </div>
                        </form>
                    </mat-step>
                    <!-- end dados cadastrais -->
                    <!-- dados familiáres -->
                    <mat-step [stepControl]="secondFormGroup" [editable]="isClienteId()">
                        <form [formGroup]="secondFormGroup">
                            <ng-template matStepLabel>Dados Familiares</ng-template>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <app-lista-estrutura-familiar
                                    style="width: 100%"
                                    [cliente_id]="data"
                                    *ngIf="isClienteId()"
                                ></app-lista-estrutura-familiar>
                            </div>
                            <div>
                                <button mat-button matStepperPrevious>
                                    <mat-icon class="s-20">navigate_before</mat-icon> Voltar
                                </button>
                                <button mat-button matStepperNext>
                                    Avançar <mat-icon class="s-20">navigate_next</mat-icon>
                                </button>
                            </div>
                        </form>
                    </mat-step>
                    <!-- end dados familiáres -->
                    <!-- Dados Financeiros -->
                    <mat-step [stepControl]="fourthFormGroup" [editable]="isClienteId()">
                        <form [formGroup]="fourthFormGroup" (ngSubmit)="salvar(stepper)">
                            <ng-template matStepLabel>Dados Financeiros</ng-template>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <p>
                                    Conhecendo os custos de vida do cliente conseguimos otimizar a carteira de
                                    investimentos, alinhan- do a necessidade de liquidez ao valor que proporcione
                                    tranquilidade e segurança. Isso vai lhe permi- tir montar uma carteira com maior
                                    diversificação de risco e liquidez, além de auxiliar na percepção e na construção da
                                    independência financeira da pessoa.
                                </p>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                                <app-lista-cliente-custo
                                    style="width: 100%"
                                    [cliente_id]="data"
                                    *ngIf="isClienteId()"
                                ></app-lista-cliente-custo>
                            </div>
                            <div>
                                <button mat-button matStepperPrevious>
                                    <mat-icon class="s-20">navigate_before</mat-icon> Voltar
                                </button>
                                <button mat-button type="submit">
                                    Avançar <mat-icon class="s-20">navigate_next</mat-icon>
                                </button>
                            </div>
                        </form>
                    </mat-step>
                    <!-- End Dados Financeiros -->
                    <!-- receitas -->
                    <mat-step [stepControl]="thirdFormGroup" [editable]="isClienteId()">
                        <form [formGroup]="thirdFormGroup">
                            <ng-template matStepLabel>Receitas</ng-template>
                            <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                                <p>
                                    <strong
                                        >Importante: Renda Passiva > Custo de Vida = Independência Financeira</strong
                                    >
                                </p>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                                <app-lista-cliente-receita
                                    style="width: 100%"
                                    [cliente_id]="data"
                                    *ngIf="isClienteId()"
                                ></app-lista-cliente-receita>
                            </div>
                            <div>
                                <button mat-button matStepperPrevious>
                                    <mat-icon class="s-20">navigate_before</mat-icon> Voltar
                                </button>
                                <button mat-button matStepperNext>
                                    Avançar <mat-icon class="s-20">navigate_next</mat-icon>
                                </button>
                            </div>
                        </form>
                    </mat-step>
                    <!-- end receitas -->

                    <!-- Patrimônio -->
                    <mat-step [stepControl]="fifthFormGroup" [editable]="isClienteId()">
                        <form [formGroup]="fifthFormGroup">
                            <ng-template matStepLabel>Patrimônios</ng-template>
                            <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                                <p>
                                    Levantar o Patrimônio Não Financeiro do seu cliente vai nos permitir auxiliá-lo a
                                    reduzir o impacto tributário em uma eventual sucessão.
                                </p>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                                <app-lista-cliente-patrimonio
                                    style="width: 100%"
                                    [cliente_id]="data"
                                    *ngIf="isClienteId()"
                                ></app-lista-cliente-patrimonio>
                            </div>
                            <div>
                                <button mat-button matStepperPrevious>
                                    <mat-icon class="s-20">navigate_before</mat-icon> Voltar
                                </button>
                                <button mat-button matStepperNext>
                                    Avançar <mat-icon class="s-20">navigate_next</mat-icon>
                                </button>
                            </div>
                        </form>
                    </mat-step>
                    <!-- End Patrimônio -->
                    <!-- Projetos -->
                    <mat-step [stepControl]="sixthFormGroup" [editable]="isClienteId()">
                        <form [formGroup]="sixthFormGroup">
                            <ng-template matStepLabel>Projetos</ng-template>
                            <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                                <p>
                                    Investidores buscam acumular e maximizar seus investimentos para realizar seus
                                    Sonhos e Projetos! Auxilie seu cliente em externar seus planos patrimoniais, sua
                                    meta de valor financeiro aplicado, compra ou atualização de veículo, aquisição de
                                    imóvel de veraneio, expansão patrimonial, reforma ou construção, viagem
                                    internacional ou qualquer aquisição de valor expressivo que deseje realizar. Desta
                                    forma, podemos alocar seus recursos de forma otimizada e apresentar alternativas
                                    inteligentes de financiamento, participando destes importantes momentos da vida
                                    dele.
                                </p>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                                <p>
                                    <strong
                                        >Importante: Em projeto, descrever o que o cliente sonha, como aquisição de
                                        imóveis e carros, faculdade dos filhos, etc...</strong
                                    >
                                </p>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                                <app-lista-cliente-projeto
                                    style="width: 100%"
                                    [cliente_id]="data"
                                    *ngIf="isClienteId()"
                                ></app-lista-cliente-projeto>
                            </div>
                            <div>
                                <button mat-button matStepperPrevious>
                                    <mat-icon class="s-20">navigate_before</mat-icon> Voltar
                                </button>
                                <button mat-button matStepperNext>
                                    Avançar <mat-icon class="s-20">navigate_next</mat-icon>
                                </button>
                            </div>
                        </form>
                    </mat-step>
                    <!-- End Projetos -->
                    <!-- Indicações -->
                    <mat-step [editable]="isClienteId()">
                        <ng-template matStepLabel>Indicações</ng-template>
                        <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                            <p>
                                Após apresentar nossa Proposta de Relacionamento na Prosperidade Investimentos e alinhar
                                a frequência de contato que será realizada, é fundamental mostrar ao cliente a
                                importância de receber o feedback dele sobre a experiência conosco, validando nosso
                                processo de melhoria contínua e o nosso interesse em construir novos relacionamentos com
                                amigos e familiares que ele recomende.
                            </p>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
                            <app-lista-cliente-indicacao
                                style="width: 100%"
                                [cliente_id]="data"
                                *ngIf="isClienteId()"
                            ></app-lista-cliente-indicacao>
                        </div>
                        <div>
                            <button mat-button matStepperPrevious>
                                <mat-icon class="s-20">navigate_before</mat-icon> Voltar
                            </button>
                        </div>
                    </mat-step>
                    <!-- End Indicações -->
                </mat-horizontal-stepper>
            </div>
            <!-- / CONTENT -->
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
